<template>
  <refund-list :shopType="0"></refund-list>
</template>

<script>

import QcContainer from "@/components/el/layout/qc-container.vue";
import PageRequest from "@/components/base/page-request.vue";
import TButton from "@/components/el/t-button.vue";
import BButton from "@/components/el/b-button.vue";
import ExportExcel from "@/components/base/ExportExcel.vue";
import RefundList from "@view/components/order/refund-list.vue";

export default {
  name: "refund",
  components: {RefundList},
  mixins: [tableBase],
  methods: {},
  mounted() {

  }
}
</script>

<style scoped>

</style>
